/**
 * A self-serve demo firm says so, everywhere, with the days left.
 *
 * Without it a prospect cannot tell sample data from their own, and finds out the demo
 * has ended only when sign-in refuses them. Renders nothing for a real firm.
 */

import { useAuth } from '@/auth/AuthProvider';

const CONTACT = 'service@wpcodie.com';

export function daysLeft(expiresAt: string, now: Date = new Date()): number {
  const ms = new Date(expiresAt).getTime() - now.getTime();
  return Math.max(0, Math.ceil(ms / 86_400_000));
}

export function DemoBanner() {
  const { me } = useAuth();
  const expiresAt = me?.organization?.demo_expires_at;
  if (!expiresAt) return null;

  const left = daysLeft(expiresAt);
  const ends = new Date(expiresAt).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
  });

  return (
    <div
      role="note"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-hero px-4 py-2 text-center text-sm text-hero-ink"
    >
      <span className="rounded-full bg-accent px-2 py-0.5 text-xs font-semibold text-hero">
        Demo
      </span>
      <span>
        {left === 0 ? 'Your demo ends today' : `${left} day${left === 1 ? '' : 's'} left`}{' '}
        <span className="text-hero-muted">(until {ends}). Sample data only.</span>
      </span>
      <span className="text-hero-muted">
        Keep it? Write to <span className="select-all font-medium text-hero-ink">{CONTACT}</span>
      </span>
    </div>
  );
}
